import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit'

type MySalesState = {
  pages: Record<string, number>;
  perPage: number;
  filters: Record<string, Record<string, any>>;
  tab: string;
  scrollPositions: Record<string, number>;
}

const initialState: MySalesState = {
  pages: {},
  perPage: 24,
  filters: {},
  tab: 'all',
  scrollPositions: {},
};

const salesHistorySlice = createSlice({
  name: 'salesHistory',
  initialState,
  reducers: {
      setPage: (state, action: PayloadAction<number | { tab: string; page: number }>) => {
        if (typeof action.payload === 'object') {
          state.pages[action.payload.tab] = action.payload.page;
        } else {
          state.pages[state.tab] = action.payload;
        }
      },
      setFilters(state, action: PayloadAction<Record<string, any>>) {
        const tab = state.tab;
        state.pages[tab] = 1;
        state.filters[tab] = action.payload;
      },
      setTab(state, action: PayloadAction<string>) {
        state.tab = action.payload;
      },
      setExternalFilters(state, action: PayloadAction<{ filters: Record<string, any>; tab?: string }>) {
        const tab = action.payload.tab || state.tab;
        state.pages[tab] = 1;
        state.filters[tab] = action.payload.filters;
      },
      resetFilters(state) {
        const tab = state.tab;
        state.pages[tab] = 1;
        state.filters[tab] = {};
      },
      saveScrollPosition(state, action: PayloadAction<{ tab: string; position: number }>) {
        state.scrollPositions[action.payload.tab] = action.payload.position;
      }
    }
});

export const { setPage, setFilters, setExternalFilters, setTab, resetFilters, saveScrollPosition } = salesHistorySlice.actions

const EMPTY_FILTERS: Record<string, any> = {};
export const selectTabFilters = (state: any, tab: string): Record<string, any> =>
  state.salesHistory.filters[tab] || EMPTY_FILTERS;

export default salesHistorySlice;
